import {
  USERTYPE_ALL_GET, USERTYPE_ALL_GET_SUCCESS, USERTYPE_ALL_GET_FAILURE
} from './mutation-types'

export default {
  state: {
    usertypesAll: []
  },
  getters: {
    usertypesAll: state => {
      return state.usertypesAll
    }
  },
  actions: {
    [USERTYPE_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      dispatch('apiGet', {url: '/master/user_types/all_get', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USERTYPE_ALL_GET_FAILURE, res.data)
          } else {
            commit(USERTYPE_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [USERTYPE_ALL_GET_FAILURE] (state, data) {
      console.log('USERTYPE_ALL_GET_FAILURE')
    },
    [USERTYPE_ALL_GET_SUCCESS] (state, data) {
      console.log('USERTYPE_ALL_GET_SUCCESS')
      state.usertypesAll = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/usertype.js